import { render } from "./JoinAsProviderPage.vue?vue&type=template&id=9cef86d4&scoped=true"
import script from "./JoinAsProviderPage.vue?vue&type=script&lang=js"
export * from "./JoinAsProviderPage.vue?vue&type=script&lang=js"

import "./JoinAsProviderPage.vue?vue&type=style&index=0&id=9cef86d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cef86d4"]])

export default __exports__